import React from 'react';
import { ActivityIndicator, View } from 'react-native';
import { createStyles } from '@/contexts/theme-context';
import { Typography, TypographyVariant } from '@usepepper/ui/atoms/typography';

const ACTIVITY_INDICATOR_SIZE = 12;

interface OrderSummaryMetricProps {
  isLoading?: boolean;
  title: string;
  value: string;
  valueVariant?: TypographyVariant;
}

export const OrderSummaryMetric: React.FC<OrderSummaryMetricProps> = ({
  isLoading,
  title,
  value,
  valueVariant = 'paragraph-md-600',
}) => {
  const [styles, theme] = useStyles();

  return (
    <View style={styles.orderSummaryMetric}>
      <Typography
        color={theme.sk.color.text.secondary}
        numberOfLines={1}
        variant="paragraph-md"
      >
        {title}
      </Typography>
      <View style={styles.commissionMetricValue}>
        <Typography
          color={
            isLoading
              ? theme.sk.color.text.disabled
              : theme.sk.color.text.primary
          }
          numberOfLines={1}
          variant={valueVariant}
        >
          {value}
        </Typography>
        {isLoading ? (
          <ActivityIndicator
            color={theme.sk.color.text.disabled}
            size={ACTIVITY_INDICATOR_SIZE}
          />
        ) : null}
      </View>
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  commissionMetricValue: {
    alignItems: 'center',
    flexDirection: 'row',
    gap: theme.sk.spacing.spaceXsmall,
  },
  orderSummaryMetric: {
    flexDirection: 'column',
    flexShrink: 1,
    minWidth: 0,
  },
}));
